export const JsmFeaturesEnabledResourceType: string = 'JSM_FEATURES_ENABLED';
